import { connect } from 'react-redux'
import LeaguesPlugin from '../../components/leagues-plugin'

const mapStateToProps = state => ({...state.leaguesPlugin})

const mapDispatchToProps = dispatch => ({
})

export default connect(mapStateToProps, mapDispatchToProps)(LeaguesPlugin)
